import React from "react";

export default function Documents() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Documents</h1>
      <p>Manage employee documents and company policies on this page.</p>
      {/* Add file upload / download functionality here */}
    </div>
  );
}
